export default {
    "landing.banner.title": "Buy & Sell Collectibles all around the world",
    "landing.banner.description": "LOTG is where the world’s top collectors buy and sell rare authenticated collectibles from verified and trusted sources.",
    "landing.banner.link.how-it-works": "See how it works",
    "landing.latest-equipment": "Latest Listings",
    "landing.sold-equipment": "Sold Collectibles",
    "landing.banner.link.hoow-it-works": "How it works",

    "landing.saved-to-watch-list": "Saved to Watchlist",
    "landing.removed-from-watch-list": "Removed from Watchlist",

    "buttons.buy-equipment": "BUY",
    "buttons.sell-equipment": "SELL",
    "buttons.request-equipment": "REQUEST",
    "buttons.one-of-one": "1of1",
    "buttons.become-dealer": "Become an Official Dealer",

    "services.register-sellers.title": "First Land Surveying Platform",
    "services.register-sellers.content": "LOTG is the first online platform specially designed for Land Surveying professionals around the world.",
    "services.certified-inspection.title": "A Unique Business Model",
    "services.certified-inspection.content": "We offer a hassle-free service, where we handle all the logistics, including: instrument pickup, shipping, and after-sales service.",
    "services.worldwide-delivery.title": "Users are Sellers & Buyers",
    "services.worldwide-delivery.content": "Users can be both sellers and buyers:",
    "services.worldwide-delivery.content1": " Manufacturers & their distributors",
    "services.worldwide-delivery.content2": " Collectible rental companies ",
    "services.worldwide-delivery.content3": " End users",
    "services.worldwide-delivery.content4": "Traders",
    "services.register-sellers.title": "Register sellers",
    "services.register-sellers.content": "We certify all our registered sellers before authorizing their listing on LOTG We are committed to ethical behavior and to act at all times with the highest degree of honesty, integrity, accountability, and propriety.",
    "services.certified-inspection.title": "Certified Inspection",
    "services.certified-inspection.content": "When an order is placed, we pick up the collectibles and send it for a physical inspection. We inspect, certify and validate each instrument before any transaction takes place.",
    "services.worldwide-delivery.title": "Worldwide delivery",
    "services.worldwide-delivery.content": "We are present in more than 60 countries with thousands of active users! We'll deliver anywhere through our partnership with DHL Express courier.",


    "authentication.authentication-failed": "Authentication failed",
    "authentication.reset-password.email-sent": "Your request has been submitted, Please check your email address",
    "post-a-req": "Please Sign up/Login To Post a Request",
    "product": "view product",
    "view-product": "VIEW PRODUCT DETAILS",

    "Equpment.goTo-RFQ.text": "Can’t find what you are looking for? Post a request now",
    "Equpment.goTo-RFQ.button": "POST A REQUEST",

    "Equipment.listView.display.more-offer": "more offers",
    "Equipment.listView.display.availble-on": "available on",
    "Equipment.listView.display.availble-store": "store",
    "Equipment.listView.display.availble-on-the": "available on the",

    "Product-display.details.title": "Product details",
    "Product-display.details.Watchlist": "Watchlist",
    "Product-display.details.Seller": "Contact Seller",
    "Product-display.details.Send-offer": "Send offer",
    "Product-display.details.Add-to-cart": "ADD TO CART",

    "Product-display.details.views": "views",
    "Product-display.details.watchlists": "watchlists",
    "Product-display.details.Store": "Lotg Store",

    "Product-display.details.Payment": "Payment",
    "Product-display.details.Delivery": "Delivery",
    "Product-display.details.Returns": "Returns",

    "Product-display.details.seller-details": "Seller details",
    "Product-display.details.Certified": "Certified Seller",
    "Product-display.details.Since": "Since",

    "Product-display.details.feedback": "positive feeddback",
    "Product-display.details.save-seller": "Save this seller",
    "Product-display.details.see-other-equipments-from-seller": "See other collectibles from this seller",

    "Product-display.details.confidence": "Shop with confidence on LOTG.com.",
    "Product-display.details.protection": "Money Protection Scheme",
    "Product-display.details.read-more": "Read more",

    "Product-display.details.Similar-Kits": "Similar collectibles",
    "Product-display.details.COMPARE": "COMPARE",

    "Product-display.details.Description": "Description",
    "Product-display.details.Details": "Details",
    "Product-display.details.Specs": "Specs",
    "Product-display.details.Brochures": "Brochures",
    "Product-display.details.Shippings-&-Payments": "Shippings & Payments",

    "Product-display.details.table.title": "Items in this collectible",
    "Product-display.details.table.Serial": "Serial",
    "Product-display.details.table.Year": "Year",
    "Product-display.details.table.quantity": "Qty",
    "Product-display.details.table.Condition": "Condition",

    "Product-display.details.table.product-Details": "Product details",
    "Product-display.details.table.Messages-&-Files": "Messages",
    "Product-display.details.table.Delivery-progress": "Delivery progress",


    "sell-equipment-option-title": "Options",
    "sell-equipment-option-Each-item-can-be-sold": "Each item can be sold independantly",
    "sell-equipment-option-negotiation-on": "Price Open to Negotiation",
    "sell-equipment-option-negotiation-off": "NOT open to price negotiation",
    "sell-equipment-option-rent": "Open to rentals",
    "sell-equipment-option-Warranty": "Warranty",
    "sell-equipment-certicates1": "Upload Files* ",
    "sell-equipment-certicates2": "Private",

    "sell-equipment-Title": "Ad Title",
    "sell-equipment-Title-place-holder": "Title",
    "sell-equipment-Keywords": "Keywords (separated by comma)",
    "sell-equipment-Keywords-place-holder": "Enter Keywords here",
    "sell-equipment-Description": "Description",
    "sell-equipment-Description-place-holder": "Description",
    "sell-equipment-images1": "Upload Images*",
    "sell-equipment-images2": "Ads with images are consulted 3x more on average",

    "sell-equipment-price": "Net to Seller",

    "sell-equipment-header-title": "Creating a new listing",
    "sell-equipment-header-save-draft": "SAVE DRAFT",
    "sell-equipment-header-back": "BACK",
    "sell-equipment-header-next": "Next",
    "sell-equipment-header-publish": "SUBMIT MY REQUEST",
    "sell-equipment-header-update": "UPDATE MY REQUEST",

    "header-Home": "Home",
    "header-buy": "BUY",
    "header-sell": "SELL",
    "header-request": "REQUEST",
    "header-become-a-partner": "Become a Partner",

    "sell-equipment-suggested-item-title": "often sold with",

    "sell-equipment-table-type": "Type",
    "sell-equipment-table-Item": "Item",
    "sell-equipment-table-serial": "Serial",
    "sell-equipment-table-condition": "Condition",
    "sell-equipment-table-qty": "Qty",
    "sell-equipment-table-empty": "Use the search above to add items to your kit",


    "filter.narrow-title": "Narrow down results using filters",
    "filter.fields.save": "Apply Filter",
    "filter.fields.reset": "Reset",
    "filter.fields.search": "Search",

    "order-table-status": "Status",
    "order-table-title": "Title",
    "order-table-item-in-kit": "Item in kit",
    "order-table-views": "Views",
    "order-table-watchlist": "Watchlist",
    "order-table-price": "Price",
    "order-table-empty": "You have no orders yet...",

    "rfp-table-status": "Status",
    "rfp-table-title": "Title",
    "rfp-table-budget": "Budget",
    "rfp-table-offers-range": "Offers range",
    "rfp-table-offers-count": "Offers count",
    "rfp-table-deadline": "Deadline",
    "rfp-table-dateposted": "Date Posted",


    "about-us-header-navigator-1": "How it works?",
    "about-us-header-navigator-3": "Our services",
    "about-us-header-navigator-4": "Our approach to quality",
    "about-us-header-navigator-5": "Blog & News",

    "about-us-first-row-mid-title-1": "Selling collectible",
    "about-us-first-row-mid-title-2": "Buying collectible",
    "about-us-first-row-mid-title-3": "Posting A Request",
    "about-us-first-row-card-description-1": "Develop a strong advertisement to your item by posting a detailed description supported by actual pictures.",
    "about-us-first-row-card-description-2": "LOTG reviews the post and approves or disapproves it.",
    "about-us-first-row-card-description-3": "You will need to renew your post and confirm its availability every 30 days.",
    "about-us-first-row-card-description-4": "The request will be reviewed by LOTG and once approved will be broadcast to all users.",
    "about-us-first-row-card-description-5": "Sellers will be able to make offers on collectible so that they can get the best price possible.",
    "about-us-first-row-card-description-6": "Sellers and buyers enter into a negotiation before the MATCH is done.",
    "about-us-first-row-card-title-1": "Submit your post",
    
    "about-us-first-row-card-title-2": "Post is reviewed by LOTG",
    "about-us-first-row-card-title-3": "Renew your post every 30 days",
    "about-us-first-row-card-title-4": "Submit your request",
    "about-us-first-row-card-title-5": "Make an offer",
    "about-us-first-row-card-title-6": "Negotiate & buy",
    "about-us-first-row-button": "Start Selling Now",
    "about-us-first-row-button1": "Start Buying",
    "about-us-first-row-button2": "Start Requesting",
    "about-us-first-row-button": "START SELLING",
    "about-us-first-row-button1": "START BUYING",
    "about-us-first-row-button2": "START POSTING",
    "how-it-works-title": "How It Works ",




    "about-us-second-row-mid-title-1": "Buying collectibles",
    "about-us-second-row-card-description-1": "Use our search engine to find the items and specs you are after. Not there? Not a problem. The request for purchase section is designed so we can find the item on your behalf.",
    "about-us-second-row-card-title-1": "Find it (or post an RFP)",
    "about-us-second-row-card-description-2": "Our easy check-out process is very direct and secure.",
    "about-us-second-row-card-title-2": "Buy it/Checkout",
    "about-us-second-row-card-description-3": "Our main service is to ensure that customers receive legitimate, and certified collectibles. Once the collectible passes quality control it shall be delivered anywhere.",
    "about-us-second-row-card-title-3": "Receive it once inspected",
    "about-us-second-row-button": "Start Buying",

    "about-us-third-row-mid-title-1": "Buying a collectible",
    "about-us-third-row-card-description-1": "",
    "about-us-third-row-card-title-1": "Funds are hold until collectible is inspected & certified",
    "about-us-third-row-card-description-2": "Because customer satisfaction is our top priority, we tend to offer a full refund for item returns. ",
    "about-us-third-row-card-title-2": "Not happy? Get reimbursed",

    "about-us-our-story-big-title": "Our story",
    "about-us-our-story-mid-title": "Where it all started - Connecting buyers & sellers",
    "about-us-our-story-first-content-title": "What do we really do ?",
    "about-us-our-story-second-content-title": "Connecting buyers & sellers",
    "about-us-our-story-description-p1": "In this digital Era, we gather from all around the world, accurate collectibles that provide dedicated precision and data collection to all professionals in the surveying and engineering fields.",
    "about-us-our-story-description-p2": "Unlike any generic marketplace, LOTG is the first online platform specially designed for all professionals around the world.",

    "about-us-our-story-description-p3": "Our mission is to make the life of land surveyors easier, by matching demand and offer for geospatial collectibles through this platform.",

    "about-us-our-story-description-p4": "Request what you are looking for by contacting us and we will find it for you!",
    "about-us-our-story-primary-action": "Sell collectibles",
    "about-us-our-story-secondary-action": "Buy collectibles ",
    "about-us-carousel-title": "Here is what our clients say",

    "about-us-our-service-big-title": "Our Collectibles",
    "about-us-our-service-description": "Our collectibles will mainly be, but not limited to, the Following:",
    "about-us-checkmark-title-1": "TRADING CARDS",
    "about-us-checkmark-description-1": "Each collectible from all categories and brands are inspected and certified by our team of professionals prior to delivery.",
    "about-us-checkmark-title-2": "JERSEYS",
    "about-us-checkmark-description-2": "All registered sellers must provide verification documents for every listed collectibles on LOTG . Once inspection and certification are validated by our team of professionals, sellers can start selling on our marketplace.",
    "about-us-checkmark-title-3": "GAME USED",
    "about-us-checkmark-description-3": "our platform offers no risk of fraudulent payments for both parties. All transactions are made between LOTG and the buyer/seller. We are the direct contact point to settle any payment, be it payment from the buyer or payment to the seller.",
    "about-us-checkmark-title-4": "MAGAZINES",
    "about-us-checkmark-description-4": "Wherever you are in the world, we'll deliver any land surveying material you need though our partnership with DHL Express courier.",
    "about-us-checkmark-title-5": "ART",
    "about-us-checkmark-description-5": "Contact us at any time and one of our agents will be happy to assist you!",
    "about-us-checkmark-title-6": "WATCHES",
    "about-us-checkmark-title-7": "TOYS",
    "about-us-checkmark-title-8": "COINS",
    "about-us-checkmark-title-9": "NFTs",
    "about-us-checkmark-title-10": "CLASSIC CARS",


    "about-us-our-approach-big-title": "The Founders",
    "about-us-our-approach-m-title1": "Ramzi Traboulsi",
    "about-us-our-approach-m-title2": "Majd Aboulhosn",
    "about-us-our-approach-m-title3": "Nathalie Mamo",
    "about-us-our-approach-m-title4": "Zein Rachidi",
    "about-us-our-approach-mid-title": "Trusted Sellers",
    "ramzi-desc":"Ramzi, is a multifaceted entrepreneur with a versatile background: from owning and managing a series of restaurants to founding his own tech company, his thirst for opportunities and chasing his passions has never seized. Ramzi is an avid fan and a collector of sports memorabilia and is the proud owner of an extensive assortment of basketball mementos, gathered from all over the world in a span of 25 years.", 
    "ramzi-desc-1":"His passion and dedication led him to find precious and rare items, sure to impress even the most inveterate collectors. He is recognized and highly touted in collecting circles around the world.",
    "ramzi-desc-2":" One of the Middle East’s authorities on sports collectibles and specifically sports cards. Ramzi has a very wide professional network in the industry at the highest levels of management and recognition.",
    "majd-desc":"Majd is an entrepreneur with an industrial engineering background. After completing his graduate studies at Harvard University and University of Cambridge, he worked in senior management and multi-billion dollar industrial projects throughout the middle east.",
    "majd-desc-1":" Majd then ventured off on his own on a path of entrepreneurship, where he founded Coast & City LLC, a boutique real estate",
    "majd-desc-2":"nvestment and management firm based in Southern California and working in some of the world’s most luxurious Zip codes. Today Majd continues to grow his company while also investing in or on the board of several successful startups (Holidayme, The Cohort). While pursuing the growth of his professional career, Majd never forgot about the passion he had forcollecting rare items as a child. Acquiring rare tangible collectibles has always been a lucrative and passionate hobby of his that he pursues perpetually.    ",
    "nathalie-desc":"Born in a sports family, Nathalie grew up to become a professional basketball player since the age of 11. She was the youngest Arab player to ever play in first division at that age and join both the Junior and the Women National Team by the age of 13. Throughout the years she has presented several sports and motor shows as well as created her own show dedicated for women athletes. Over the past 10 years Nathalie has been an anchor of sports coverage in the region’s sports media. She worked for Sky",
    "nathalie-desc1":"News Arabia, OSN and MBC. She hosted and created some of the most successful sports such as “WWE Wal3ooha” “WWE Al An” (WWE Now) covering all the WWE content for the region. Along with the above, In 2014, Nathalie was chosen to be the main host of the biggest Sports TV Reality show in the region “THE VICTORIOUS”, where she presented the daily episodes along with the weekly primes. The jury on the show were the biggest football legends such as: Diego Maradona, Thierry Henry, Ronaldo, Ronaldinho, Ryan Giggs, Raul, Fabio Cannavaro, Roberto Carlos, Luis Figo and many others. Nathalie is today considered a leading figure in sports media in the region. On November 28th 2017, Nathalie was chosen to host and moderate the “Asian Women Journalists Summit” and on December 28th 2017, Nathalie was the first Arab to be hosting the “Globe Soccer Awards”, which she had the chance to host it again in 2018, 2019 and 2020. In 2021, Nathalie was the first woman to be chosen as Sports Media Personality of the year before being chosen to host the launch of the FIFA World Cup 2022 Official Match ball. Her strong online following and fans are a testament to her professionalism and likability.",
    "zein-desc":"Zein is an engineer and serial entrepreneur with 15 years of experience. He has founded several successful tech companies which operate globally. His professional career covers an impressive global reach from the Middle East to Europe and the US.",
    "zein-desc-1":" His track record of creating companies and scaling them to success has attracted the interests of institutional investors. One of his earliest forays in the world of entrepreneurship was Topotrade, an online marketplace for construction equipment, has since",
    "zein-desc-2":"become a market leader in the industry. The success of the company was largely due to the design and user experience of their online platform. In addition to Topotrade, Zein has founded Levant IT, a software development company, and Digital Realities, a high-tech solution for creating digital twins.",
    "zein-plus":"Building smart marketplaces for niche markets",
    "about-us-our-approach-m-titl1": "Co-Founder & CEO",
    "about-us-our-approach-m-titl2": "Co-Founder",
    "about-us-our-approach-m-titl3": "Co-Founder & Brand Ambassador",
    "about-us-our-approach-m-titl23": "Co-Founder-Tech",
    "founder-desc-10": "Building smart marketplaces for niche markets",
    "about-us-our-approach-description-p1": "We certify all our registered sellers before authorizing their listing on LOTG",

    "about-us-our-approach-description-p2": "Legends of the game is committed to ethical behavior and to act at all times with the highest degree of honesty, integrity, accountability, and propriety.",

    "about-us-our-approach-description-p3": "It is amongst its first priorities to establish strict guidelines abiding by the anti-fraud and anti-theft rules and regulations, in order to guaranty the liability and validity of each collectible. We have place strict procedures to prevent any fraudulent/stolen collectible from being listed on LOTG.",
    "about-us-our-approach-card-title-1": "Trusted sellers",
    "about-us-our-approach-card-desc-1": "We ask for company documents & check the company if it is actually legitimate",
    "about-us-our-approach-card-title-2": "Proof of ownership",
    "about-us-our-approach-card-desc-2": "New customers need to provide proof of ownership in order to add a new listing on Legends of the game",
    "about-us-our-approach-card-title-3": "instrument Serial number",
    "about-us-our-approach-card-desc-3": "We compare serial numbers with the manufacturer database in order to confirm the product tracability",

    "about-us-quality-guarantee-title": "Quality Guarantee",
    "about-us-quality-guarantee-desc-p1": "Only verified users are allowed to list their collectibles for sale. To avoid fake accounts any fraudulent users we have put multiple processes in place, supported also by technology that prevents bots from creating accounts. We also investigate all new potential-sellers and request all necessary documents to validate their identity",
    "about-us-quality-guarantee-desc-p2": "When an order is placed, we pick up the collectibles and send it for a physical inspection where our inspection center makes sure you get exactly what you ordered. (undeclared damages, list of accessories, Serial Number). We follow strict procedures to prevent and fraudulent/stolen collectible to ever be listed on LOTG as per our Trusted sellers rules and regulations.",
    "about-us-quality-guarantee-card-title-1": "Serial & article number",
    "about-us-quality-guarantee-card-desc-1": "Once the collectibles reaches our inspection center, we initially verify its serial number and article number, making sure all items match the description provided by the seller.",
    "about-us-quality-guarantee-card-title-2": "Inventory of accessories",
    "about-us-quality-guarantee-card-desc-2": "We then examine if the accessories list provided by the seller is accurate and that each item is available as per description.",
    "about-us-quality-guarantee-card-title-3": "Functions",
    "about-us-quality-guarantee-card-desc-3": "We inspect the functionality of the collectibles and to make sure it's in working condition.",
    "about-us-quality-guarantee-card-title-4": "Cleaning & Packaging",
    "about-us-quality-guarantee-card-desc-4": "Once all the above steps are validated, we clean the items before wrapping and packaging them robustly to proceed to the shipping step and delivery to the customer.",

    "footer-get-to-know-us": "GET TO KNOW US",
    "footer-about-us": "About Us",
    "footer-contact-us": "Contact Us",
    "footer-blog": "Blog",
    "footer-newsroom": "News room",
    "footer-career": "Career",
    "footer-earn-money": "SELL",
    "footer-make-money-with-us": "Become A Dealer",
    "footer-create-your-listings": "Create your listings",
    "footer-buy": "BUY",
    "footer-shop-all-equipments": "Shop all collectibles",
    "latest-requests": "Latest Requests",
    "footer-special-offers": "Special offers",
    "footer-your-account": "YOUR ACCOUNT",
    "footer-your-dashboard": "Your dashboard",
    "footer-order-tracking": "Order tracking",
    "footer-signup-login": "Sign up / Login",
    "footer-code": "© legendsownthegame.com All rights reserved from 2023 to ",
    "footer-privacy-policy": "Privacy Policy",
    "footer-terms-of-service": "Terms of Service",


    "ask-que-help1": "Frequently asked questions",
    "ask-que-help2": "HOW CAN WE HELP ?",
    "signin-login": "Login",
    "Clear-filters": "CLEAR FILTERS",

    "contactus-content1": "We are available from Monday to Friday 9:00am - 12:30pm & 2:00pm - 7:00pm GMT+1. ",
    "contactus-content2": "Please feel free to contact us on any of our addresses below, or fill the form for any specific inquiries.",
    "contactus-content3": "For Support / Technical Help / General Enquiries",
    "contactus-content4": "We aim to reply within 2 business days.",
    "contactus-content5": " If you don’t hear back from us after 3 days, please give us a call.",
    "contactus-content6": "Live Chat",
    "contactus-content7": "You can start the live chat by clicking on the chat icon on the",
    "contactu-content7":" bottom right. Start live chat (2 agents online)",
    "contactus-content8": "Start live chat (2 agents online)",
    "contactus-content9": "Legends Own the Game LLC - Dubai - Al Barsha 1 King Badr Saif Saoud Aljabiri F146 - Office #5",
    "contactus-content10": "This is our postal address for letters.",
    "contactus-content11": "Please do not send equipment to this address.",
    "contactus-content12": "contact{'@'}LOTG.com",
    "contactus-content13": "+ 971 50 969 3925",
    "contact-name": "Name",
    "contact-email": "Email",
    "contact-subject": "Subject",
    "contact-message": "Message",

    "post-a-req": "Please Sign up / Login To Post a Request",
    "post-request-content": "Please fill the form below as accurately as possible with your collectible description, so you can request it on LOTG.",



    "Sort-By": "Sort By:",
    "Newest-Listing": "Newest Listing",
    "Oldest-Listing": "Oldest Listing",
    "Production-Year-Descending": "Production Year Descending",
    "Production-Year-Ascending": "Production Year Ascending",
    "Price-Descending": "Price Descending",
    "Price-Ascending": "Price Ascending",
    "good-news": " Good news, the product you are looking for is available",




    "privacy-policy-1": "LOTG Cookies Policy",
    "privacy-policy-2": "Our Cookies Policy was last updated on August 20, 2022.",
    "privacy-policy-3": "This Cookies policy explains what Cookies are and how we use them.You should read this policy so you can understand what type of cookies we use, or the information we collect using Cookies and how that information is used",
    "privacy-policy-4": "Cookies do not typically contain any information that personally identifies a user, but personal information that we store about you may be linked to the information stored in and obtained from Cookies. For further information on how we use, store, and keep your personal data secure, see our Privacy Policy.",
    "privacy-policy-5": "We do not store sensitive personal information, such as mailing addresses, account passwords, etc. in the Cookies we use.",
    "privacy-policy-6": "Interpretation and Definitions:",
    "privacy-policy-7": "Interpretaion",
    "privacy-policy-8": " The words of which the initial letter in capitalized have meaning defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.",
    "privacy-policy-9": "Definitions:",
    "privacy-policy-10": "For the purposes of this Cookies Policy:",
    "privacy-policy-11": "“Company” refers to LOTG.com",
    "privacy-policy-12": "“Cookies” means small files that are placed on your computer, mobile device or any other device by a website, containing details of your browsing history on that website among its many uses.",
    "privacy-policy-13": "“Website” refers to LOTG.com, accessible from LOTG.com",
    "privacy-policy-14": "“You” means the individual accessing or using the Website, or a company, or any legal entity on behalf of which such individual is accessing or using the Website, as applicable.",
    "privacy-policy-15": "The use of the Cookies",
    "privacy-policy-16": "Type of Cookies We Use",
    "privacy-policy-17": " Cookies can be “Persistent” or “Session” Cookies. Persistent Cookies remain on your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close your web browser.",
    "privacy-policy-18": " We use both session and persistent Cookies for the purposes set out below:",
    "privacy-policy-19": "Necessary / Essential Cookies",
    "privacy-policy-20": "Type: Session Cookies",
    "privacy-policy-21": "Administered by: Us",
    "privacy-policy-22": "Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts.",
    "privacy-policy-23": "Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.",
    "privacy-policy-24": "Cookies Policy / Notice Acceptance Cookies",
    "privacy-policy-25": "Type: Persistent Cookies",
    "privacy-policy-27": "Purpose: These Cookies identify if users have accepted the use of cookies on the Website.",
    "privacy-policy-28": "Functionality Cookies",
    "privacy-policy-29": " Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference.The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.",
    "privacy-policy-30": "Tracking and Performance Cookies",
    "privacy-policy-31": "Type: Persistent Cookies",
    "privacy-policy-32": "Administered by: Third-Parties",
    "privacy-policy-33": "Purpose: These Cookies are used to track information about traffic to the Website and how users use the Website. The information gathered via these Cookies may directly or indirectly identify you as an individual visitor. This is because the information collected is typically linked to a pseudonymous identifier associated with the device you use to access the Website. We may also use these Cookies to test new advertisements, pages, features or new functionality of the Website to see how our users react to them.",
    "privacy-policy-34": "Your Choices Regarding Cookies",
    "privacy-policy-35": "If You prefer to avoid the use of Cookies on the Website, first You must disable the use of Cookies in your browser and then delete the Cookies saved in your browser associated with this website. You may use this option for preventing the use of Cookies at any time.",
    "privacy-policy-36": "If You do not accept Our Cookies, You may experience some inconvenience in your use of the Website and some features may not function properly.",
    "privacy-policy-37": "If You'd like to delete Cookies or instruct your web browser to delete or refuse Cookies, please visit the help pages of your web browser.",
    "privacy-policy-38": "For the Chrome web browser,please visit this page from Google: ",
    "privacy-policy-39": "For the Internet Explorer web browser, please visit this page from Microsoft:",
    "privacy-policy-40": "For the Firefox web browser, please visit this page from Mozilla: ",
    "privacy-policy-41": "For the Safari web browser, please visit this page from Apple:",
    "privacy-policy-42": "For any other web browser, please visit your web browser's official web pages.",
    "privacy-policy-43": "Contact Us",
    "privacy-policy-44": "If you have any questions about this Cookies Policy, You can contact us:",
    


    "post-submitted-1": "Thank you for your submission.",
    "post-submitted-2": "Your collectible request has been submitted successfully",
    "post-submitted-3": " Please allow up to 24hrs to complete the review process.    ",
    "post-submitted-4": " your collectible will be posted directly on the LOTG marketplace.",
    "post-submitted-5": "Done Listing Collectibles for now",
    "post-submitted-6": "Post another request",
    "post-submitted-7": "We will review it and, if your submission is verified to meet our listing standards,",
    "post-submitted-8": "List Another Collectible ",
    "confirmation-1": "All done.",
    "confirmation-2": "Thank you for your order!",
    "confirmation-3": "We will look for your wire transfer on our bank account and initiate the shipping.",
    "confirmation-4": "The collectible will definitely be inspected before it is delivered to you.",
    "confirmation-5": "Download my Receipt",
    "confirmation-6": "Go to my Orders",

    "header-Available-equipment": "COLLECTIBLES",
    "header-Requested-Equipment": "COLLECTOR'S CHASE",


    "footer-sell": "Sell",
    "header-faq": "FAQ",
    "footer-dashboard": "Dashboard",
    "footer-listings": "Listings",
    "footer-inbox": "Message Center",
    "footer-notification": "Notifications",
    "footer-orders": "Orders",
    "footer-settings": "Settings",
    "footer-logout": "Logout",
    "footer-workwithus": "Work with Us",

    "about-1": "What unites us",
    "about-2": "We are four entrepreneurs who have found success in various industries. What unites us is our common belief that the highest levels of success can only be reached when the driving force is your passion.",
    "about-3": "If life was a game, winning would mean understanding your passion, chasing your passion, and capturing that passion. ",
    "about-4": "We believe that those who understand and live by this mantra are legends and Legends Own the Game of life.",
    "about-5": "LOTG was created to bring people closer to their passion. LOTG is here to remind us that chasing after your passion is an essential part of owning your life regardless of your age. Whether you are a kid or an adult chasing or investing in your passion, LOTG is a part of your legendary journey.",
    "about-6": "The thrill of finding that rare sports card, comic book, sneaker, or item you love is a feeling that has no age group. The collectibles we offer bring people’s passion to life.",
    "about-7": "A game of passion",
}